/**
 * Whimstay design tokens for the v3 booking detail page.
 *
 * Namespaced under `whimstay.*` so it sits alongside the existing admin
 * palette without collisions. Values mirror the prod-validated subset the
 * prototype was built against.
 */
export const whimstay = {
  brand: {
    primary: "#003c49",
    secondary: "#008292",
    accent: "#ffdd50",
    tertiary: "#d4eaec",
  },
  gray: {
    50: "#fdfcff",
    100: "#f7f6fc",
    200: "#e5e7eb",
    300: "#d4d6de",
    400: "#bcc1d6",
    500: "#8d91a5",
    600: "#707281",
    700: "#53535d",
    900: "#26262b",
  },
  error: { 100: "#ffe7e7", 500: "#ff2f1c" },
  alert: { 100: "#fff6de", 500: "#ffac1c" },
  success: { 100: "#e8ffe9", 500: "#03ae42" },
  warning: { 600: "#a76b00" },
  /**
   * Money-direction semantics. COOL (credit) = money returned to a party.
   * WARM (charge) = money collected. Deliberately NOT error red — red is
   * reserved for validation and canceled state.
   */
  credit: { 50: "#e9f8f4", 600: "#138a78", 700: "#0f7a6b" },
  charge: { 50: "#fdeceb", 600: "#d3342a", 700: "#c0291c" },
  nearBlack: "#222222",
  pageLight: "#f8f8f8",
}

export const whimstayRadii = {
  tag: "4px",
  card: "8px",
  modal: "12px",
  dropdown: "16px",
  pill: "9999px",
}

export const whimstayShadows = {
  cardSoft: "0px 4px 12px 0px rgba(55, 56, 77, 0.1)",
  floating: "0px 4px 20px 0px rgba(55, 56, 77, 0.13)",
  modalDeep:
    "0px 1px 6px 0px rgba(0, 0, 0, 0.06), 0px 2px 32px 0px rgba(0, 0, 0, 0.16)",
}
